import angular from 'angular';
import { saveAs } from 'file-saver/FileSaver';

let UnitListController = function (Unit, $scope, $state, $filter, $mdDialog, Toast, State, City) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  $ctrl.isManager = $scope.$root.user.access_group.special_rule === 'MANAGER' || $scope.$root.user.access_group.is_super;

  angular.extend($ctrl, {
    edit, orderList, handleDelete, getMessage, onChangeState, onChangeCity, onChangeStatus
  });

  activate();

  function activate() {
    $ctrl.filter = {

    };
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    State.index({limit: 10000000000}).then(function (states) {
      $ctrl.states = states;

      $ctrl.promise;

      $ctrl.$scope.tableConfig = {
        page: 1,
        limit: 10,
        order: 'name',
        like_search: '',
        state_id: '',
        city_id: '',
        activated: null,
        like_search_fields: [
          'name',
          'address_street'
        ]
      };

      $ctrl.$scope.$watch('tableConfig', () => {
        loadData()
      }, true);
    })
  }

  function onChangeStatus(status) {
    $ctrl.$scope.tableConfig.is_visible = status
  }

  function onChangeCity(cityId) {
    $ctrl.$scope.tableConfig.city_id = cityId
  }
  function onChangeState(stateId) {
    $ctrl.filter.city_id = null;

    $ctrl.$scope.tableConfig.state_id = stateId
    $ctrl.$scope.tableConfig.city_id = ''

    $ctrl.loadingCities = true;
    City
      .index({
        state_id: stateId,
        limit: 1000000
      })
      .then(cities => {
        $ctrl.cities = cities;
        $ctrl.loadingCities = false;
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.loadingCities = false;
      });
  }
  $scope.downloadReport = function () {
    $ctrl.activeSpin = true;
    $ctrl.activeSpinButton = true;
    Unit
      .downloadReport()
      .then(function (res) {
        var file = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        let messageSuccess = $filter('translate')('report-success');
        $ctrl.activeSpin = false;
        $ctrl.activeSpinButton = false;
        Toast.success(messageSuccess);
        saveAs(file, 'rel_analitico_unidades.csv');
      }).catch(err => {
        console.log('err:', err);
        let messageError = $filter('translate')('report-error');
        $ctrl.activeSpin = false;
        $ctrl.activeSpinButton = false;
        Toast.error(messageError);
      });
  };

  function edit(id) {
    $state.go('unit.edit', { id });
  }

  function getMessage(showMessage) {
    return showMessage ? 'Existem solicitações pendentes nesta unidade!' : null;
  }

  function handleDelete(resource, event) {
    event.stopPropagation();

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('common-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('common-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Unit
          .destroy(resource)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            _.remove($ctrl.resources.data, resource);
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Unit
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        // $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.uiState = 'COMPLETE';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:', err);
        $ctrl.uiState = 'ERROR';
      });
  }
}

UnitListController.$inject = ['Unit', '$scope', '$state', '$filter', '$mdDialog', 'Toast', 'State', 'City'];

export default UnitListController;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-list.controller.js